import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return { root: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
            height: 100%;
            width: 100%;
        ` }
}

export default styles
